import varAxios from "../../Comman/axios";
import { heartRunnerRegisterUrl,getHeartRunnerOrg } from "../../Comman/apiEndPoints"

export const INSERT_HEARTRUNNER_REGISTER_REQUEST = "(registration) INSERT HEARTRUNNER REGISTER REQUEST";
export const INSERT_HEARTRUNNER_REGISTER_SUCCESS = "(registration) INSERT HEARTRUNNER REGISTER SUCCESS";
export const INSERT_HEARTRUNNER_REGISTER_ERROR = "(registration) INSERT  HEARTRUNNER REGISTER ERROR";

export const FETCH_HEARTRUNNER_ORG_REQUEST = "(registration) FETCH HEARTRUNNER ORG REQUEST";
export const FETCH_HEARTRUNNER_ORG_SUCCESS = "(registration) FETCH HEARTRUNNER ORG SUCCESS";
export const FETCH_HEARTRUNNER_ORG_ERROR = "(registration) FETCH HEARTRUNNER ORG ERROR";


export function insertHeartRunnerRequest(data,isLoading) {
    return {
        type: INSERT_HEARTRUNNER_REGISTER_REQUEST,
        data,
        isLoading
    }
}

export function insertHeartRunnerSuccess(data,statusCode,Message,isLoading) {
    
    return {
        type: INSERT_HEARTRUNNER_REGISTER_SUCCESS,
        data,
        statusCode,
        Message,
        isLoading
    }
}
export function insertHeartRunnerError(data,statusCode,isLoading) {
    
    return {
        type: INSERT_HEARTRUNNER_REGISTER_ERROR,
        data,statusCode,
        isLoading
    }
}


export function HeartRunnerRegister(data,dispatch) {
   

    return (dispatch) => {
        dispatch(insertHeartRunnerRequest(data,true));
        return varAxios.post(heartRunnerRegisterUrl, data,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                
                dispatch(
                    insertHeartRunnerSuccess(
                        response.data,
                        response.data.statusCode,
                        response.data.errorMessage,
                        false,
                    ));
            })
            .catch((error) => {
                
                dispatch(
                    insertHeartRunnerError(
                        error.response.data,
                        500,
                        false,
                    ));
                
            })
    }
}

export function fetchHeartRunnerOrg(dispatch) {
    return (dispatch) => {
        dispatch(fetchHeartRunnerOrgRequest(true));
        return varAxios.get(getHeartRunnerOrg, 
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    fetchHeartRunnerOrgSuccess(
                        response.data,
                        false,
                    ));
            })
            .catch((error) => {
                dispatch(
                    fetchHeartRunnerOrgSuccess(
                        error.response.data,
                        false,
                    ));
                
            })
    }
}

export function fetchHeartRunnerOrgRequest(data,isLoading) {
    return {
        type: FETCH_HEARTRUNNER_ORG_REQUEST,
        data,
        isLoading
    }
}

export function fetchHeartRunnerOrgSuccess(heartRunnerOrgInfo,isLoading) {
    
    return {
        type: FETCH_HEARTRUNNER_ORG_SUCCESS,
        heartRunnerOrgInfo,
        isLoading
    }
}


